export function getBookingTotalCents(booking) {
  return Math.max(
    Number(booking?.package_total_cents || 0),
    Math.round(Number(booking?.total_amount || 0) * 100)
  )
}

export const MONTHLY_99_FEE_CHANGE_AT = '2026-07-15T00:00:00.000Z'

export function getBookingProcessingFeeCents(booking) {
  const storedFee = Number(
    booking?.processing_fee_cents ??
    booking?.personalization_data?.pricing_summary?.processing_fee_cents
  )
  if (Number.isFinite(storedFee)) return storedFee

  const migrationTier = String(booking?.personalization_data?.migration?.payment_tier || '').toLowerCase()
  if (booking?.payment_plan === 'monthly199' || migrationTier.includes('monthly')) return 15000

  if (booking?.payment_plan === 'monthly99') {
    const createdAt = booking?.created_at ? new Date(booking.created_at) : null
    return createdAt && !Number.isNaN(createdAt.getTime()) && createdAt < new Date(MONTHLY_99_FEE_CHANGE_AT)
      ? 19800
      : 29700
  }

  return 0
}

export function hasProcessedPaymentIntent(paymentSchedule = [], paymentIntentId) {
  if (!paymentIntentId) return false
  return paymentSchedule.some(payment => payment?.payment_intent_id === paymentIntentId)
}

export function getCashRefundTotalCents(refunds = []) {
  return refunds
    .filter(refund =>
      refund.status === 'succeeded' &&
      (!refund.adjustment_type ||
        refund.adjustment_type === 'cash_refund' ||
        refund.adjustment_type === 'cash_and_price_reduction')
    )
    .reduce((sum, refund) => sum + Number(refund.amount_cents || 0), 0)
}

export function getPriceReductionTotalCents(refunds = []) {
  return refunds
    .filter(refund =>
      refund.status === 'succeeded' &&
      (refund.adjustment_type === 'price_reduction' ||
        refund.adjustment_type === 'cash_and_price_reduction')
    )
    .reduce((sum, refund) => sum + Number(refund.amount_cents || 0), 0)
}

export function calculateRemainingBalanceCents({ totalCents, paidCents, refunds = [] }) {
  return Number(totalCents || 0) - Number(paidCents || 0) + getCashRefundTotalCents(refunds)
}

/**
 * The ledger's rule, in one place, for screens that compute a balance from rows they already hold
 * (the client page's Booking Details). Mirrors public.booking_balances rev 2 (14 Sep 2026):
 *   contract  = agreed + late fees - recorded price reductions
 *   remaining = contract - payments + cash refunds
 * No floor: a negative result is an overpayment and the caller may say so.
 */
export function ledgerRemainingCents({ agreedCents, lateFeeCents = 0, paidCents, refunds = [] }) {
  const contract = Number(agreedCents || 0) + Number(lateFeeCents || 0) - getPriceReductionTotalCents(refunds)
  return contract - Number(paidCents || 0) + getCashRefundTotalCents(refunds)
}
